import { Component, OnInit, ElementRef, ViewChild } from '@angular/core';
import { StepIndicatorService, BreadCrumbService, PageLoaderService, DatePickerService } from 'lib/ng2-sapmp/src/ui-components';
import { ActivatedRoute, Router } from '@angular/router';
import { SignupSetupService } from '../shared/providers/signup-setup.service';
import { AdobeAnalyticsService, AuthenticationService, UtilityService } from 'lib/ng2-sapmp/src/providers';
import { FanModel, SignupSetupInputModel, SignupSetupOutputModel } from '../shared/models/signup-setup.models';
import { KEY_CONFIG } from 'lib/ng2-sapmp/src/config/key-config';
import { BaseProfileModel } from 'lib/ng2-sapmp/src/models';
import { interval } from 'rxjs';
import { exhaustMap, filter, mergeMap, takeUntil, tap } from 'rxjs/operators';
import {ERRCODES, ABMFE_CONTENTS} from 'config';

@Component({
  selector: 'app-review-signup-setup',
  templateUrl: './review-signup-setup.component.html',
  styleUrls: ['./review-signup-setup.component.scss'],
  providers: [SignupSetupService, DatePickerService, AdobeAnalyticsService]
})
export class ReviewSignupSetupComponent implements OnInit {

  selectedFanList: any;
  isGroupBased: any;
  uploadedFileName: any = '';
  @ViewChild('confirm') confirm : ElementRef;
  isDisabled: boolean = true;
  reviewSignupSetup: any;
  showErrors = false;
  submitting = false;
  notEnrolledFanList: any;
  enrollmentDate: string;
  signupSetupInputData: SignupSetupInputModel;
  signupSetupOutputData: SignupSetupOutputModel;
  private successfullySignupFAN: Array<FanModel> = [];
  prodcode: string;
  mailId: any;
  mdmdets: any;
  proddets: any;
  kme: boolean = false;
  ztp: boolean = false;
  abm: boolean = false;
  notificationType: any;
  signupdata: { };
  fansArray: { };
  initialSignup: boolean = false;
  new: string;
  existing: string;
  prof: {};
  appli: {};
  settng: {};
  email: boolean = false;
  sms: boolean = false;
  eachFan: {};
  existingDate: string;
  selectedFANs: any;
  enrollArray: any[] = [];
  signupArray: any[] = [];
  fanDetails: any[] = [];
  user: BaseProfileModel;
  ctnUser : any;
  contactNumber : any;
  secondNewFan: any;
  secondFanStatus: any;
  manageProduct: any;
  emmProductCode: any;
  selectedAccID: any;
  tranId: string;
  errorMessage: string;
  timerStart: number;
  setupError: boolean = false;
  status: boolean;
  depError: boolean = false;
  depFansList: any[] = [];
  failArray: any[] = [];
  fanInfoList : any[] = [];
  revisedFanList: any[] = [];
  fansAvailable: any;
  showFansFlag: boolean = false;
  fe: { firstName: string; lastName: string; email: string;};
  userData: any;
  firstName: any;
  lastName: any;
  userEmail: any;
  feFlag: boolean;
  checkSignup: { emmAccountId: string; emmProductCode: any; fanDetails: any[]; };
  ABMFE_payload: any;
  isFEFailed: boolean = false;
  isFEFailedWithError: boolean = false;
  ABMFESuccessMessage: string = '';
  ABMFEErrorMessage: any = '';
  ABMFEErrorMessageDescription: any = '';
  ABMFEErrorMessageFooter: any = '';
  errorDescShow: boolean = false;
  customerRoles: any[];
  showErrorModel: boolean = false;
  confirmedErrorModal: boolean = false;
  isConfirmErrorChecked: boolean = false;
  processSignup: boolean = false;
  isNewReviewPage: boolean = false;
  isOldReviewPage: boolean = false;
  isMobileView: boolean = window.innerWidth <= 768;
  signupSetupError: string = '';
    //showGoogleCreationError: boolean = false;

  constructor(private stepIndicatorService: StepIndicatorService, 
    private pageLoaderService: PageLoaderService, private utilityService: UtilityService, private authenticationService: AuthenticationService,
    private route: ActivatedRoute, private breadCrumbService: BreadCrumbService, private dateformatter: DatePickerService,
    private router: Router, private signupSetupService: SignupSetupService, private adobeAnalyticsService: AdobeAnalyticsService) {
      
      const profileData = JSON.parse(sessionStorage.getItem('user'));
      this.mailId = profileData.user.emailAddress;
    
   }

   ngOnInit() {
    if(this.router.url === '/productselection/review')  {
      this.isNewReviewPage = true;
    } else if(this.router.url === '/signupsetup/review') {
      this.isOldReviewPage = true;
    }
    this.breadCrumbService.removeLastBreadCrumb();
    this.breadCrumbService.setCurrentBreadCrumb({ label: 'Device Enrollment Program', routerLink: '/signupsetup/review' });
    this.stepIndicatorService.setCurrentStep(this.route.snapshot.url[0].path);
    this.stepIndicatorService.setVisibility(true);
    this.showErrors = false;
    // this.reviewSignupSetup = this.route.snapshot.data.pageData.productselectionreview;//this.route.snapshot.data.pageData.signupsetupreview;
    this.prodcode = sessionStorage.getItem('prodcode');
    this.mdmdets = JSON.parse(sessionStorage.getItem('mdmDetails'));
    this.proddets = JSON.parse(sessionStorage.getItem('manage-product'));
    this.reviewSignupSetup = this.route.snapshot.data.pageData.productselectionreview;
    // if (this.proddets.emmProductCode === "DMPAABM" || "DMPGZTP") {
    //   this.reviewSignupSetup = this.route.snapshot.data.pageData.productselectionreview;
    // } else {
    //   this.reviewSignupSetup = this.route.snapshot.data.pageData.signupsetupreview;
    // }
    if (this.proddets.emmProductCode === "DMPGZTP") {
      this.kme = false;
      this.ztp = true;
      this.abm = false;
    } else if (this.proddets.emmProductCode === "DMPAABM") {
      this.kme = false;
      this.ztp = false;
      this.abm = true;
    } else if (this.proddets.emmProductCode === "DMPSKME") {
      this.kme = true;
      this.ztp = false;
      this.abm = false;
    }
    this.reviewSignupSetup.PopMsgSystemFailure.description =
            this.reviewSignupSetup.PopMsgSystemFailure.description.replace('<mailId>', this.mailId);
    this.notEnrolledFanList = JSON.parse(sessionStorage.getItem('signupFanList'));
    this.selectedFanList = JSON.parse(sessionStorage.getItem('selectedSignupFanList'));
    this.enrollArray = JSON.parse(sessionStorage.getItem('enrollArray'));
    if (!this.enrollArray) {
      this.enrollArray = [];
    }

    //setting existing and enroll date
    this.enrollmentDate = this.dateformatter.formatDate('yyyy-mm-dd', new Date());
    let minDate = new Date();
    this.existingDate = this.dateformatter.formatDate('yyyy-mm-dd', new Date( minDate.getFullYear(), minDate.getMonth(), (minDate.getDate() + 1)));

    let restArray = [];
    this.selectedFanList.forEach(element => {
      if (!this.enrollArray.includes(element.fanId)) {
        restArray.push(element.fanId);
      }
    });
    console.log(restArray);

    this.enrollArray.forEach(element => {
      let data = {
        "fanId" : element,
        "enroll": true,
        "status": "Enroll",
        "new" : this.enrollmentDate,
        "existing" : this.enrollmentDate
      }
      this.signupArray.push(data);
    });

    restArray.forEach(element => {
      let data = {
        "fanId" : element,
        "enroll": false,
        "status": "Do Not Enroll",
        "new" : this.enrollmentDate,
        "existing" : ""
      }
      this.signupArray.push(data);
    });

    this.signupArray = this.signupArray.sort((a, b) => a.fanId - b.fanId);
    this.signupArray  = this.uniqueData(this.signupArray)
    sessionStorage.setItem('signedupData', JSON.stringify(this.signupArray));
    this.isDisabled = true;

    if(sessionStorage.getItem('feFlag') == "true" && this.proddets.emmProductCode === "DMPAABM"){
      this.proddets.selectedAccID = "Pending";     
    }
    //Customer roles for ABM FE
    // this.customerRoles = this.reviewSignupSetup.roles;
  }

  uniqueData(arr){ 
  const uniqueIds = [];
  const unique = arr.filter(element => {
    const isDuplicate = uniqueIds.includes(element.fanId);

    if (!isDuplicate) {
      uniqueIds.push(element.fanId);
      return true;
    }
    return false;
  });
  return unique ;
  }

  enableSubmit() {
        if(this.confirm.nativeElement.checked == true) {
            this.isDisabled = false;
        }
        else {
            this.isDisabled = true;
        }
  }

  closeOverviewModal() {
    this.showErrorModel = false;
    this.processSignup = false;
    this.isConfirmErrorChecked = false;
  }

  continueErrorModal() {
      this.processSignup = true;
      this.showErrorModel = false;
      if (this.emmProductCode === "DMPAABM" && (sessionStorage.getItem('feFlag') == "false") && this.processSignup === true) {
          this.signupProcess();
          this.pageLoaderService.setPageLoaderStatus(false);
        }
  }

  clickBack() {
    this.pageLoaderService.setPageLoaderStatus(false);
    // this.router.navigate(['/signupsetup/enrollmentoptions']);
    this.router.navigate(['/productselection/enrollmentoptions']);
    sessionStorage.setItem('backFromReview', 'true');
  }

  dismissInfo() {
    this.showErrors = false;
    this.isFEFailed = false;
    this.isFEFailedWithError = false;
  }
  // toggleTooltip(event) {
  //   if (event.type !== 'click') {
  //     if (event.keyCode !== KEY_CONFIG.enter) {
  //       return;
  //     }
  //   }
  //   let targetElement = event.target;
  //   const elems = document.querySelectorAll('.tooltipActive');
  //   let iselementActive = false;
  //   if (targetElement.classList.contains('tooltipActive')) {
  //     iselementActive = true;
  //   }
  //   [].forEach.call(elems, function (ele) {
  //     ele.classList.remove('tooltipActive');
  //   });
  //   if (iselementActive) {
  //     targetElement.classList.remove('tooltipActive');
  //   } else {
  //     targetElement.classList.add('tooltipActive');
  //   }
  // }

  toggleTooltipEnter(event) {
    if (event.type !== 'mouseenter') {
      if (event.keyCode !== KEY_CONFIG.enter) {
        return;
      }
    }
    let targetElement = event.target;
    const elems = document.querySelectorAll('.tooltipActive');
    let iselementActive = false;
    if (targetElement.classList.contains('tooltipActive')) {
      iselementActive = true;
    }
    [].forEach.call(elems, function (ele) {
      ele.classList.remove('tooltipActive');
    });
    if (iselementActive) {
      targetElement.classList.remove('tooltipActive');
    } else {
      targetElement.classList.add('tooltipActive');
    }
  }

  toggleTooltipLeave(event) {
    if (event.type !== 'mouseleave') {
      if (event.keyCode !== KEY_CONFIG.enter) {
        return;
      }
    }
    let targetElement = event.target;
    const elems = document.querySelectorAll('.tooltipActive');
    let iselementActive = false;
    if (targetElement.classList.contains('tooltipActive')) {
      iselementActive = true;
    }
    [].forEach.call(elems, function (ele) {
      ele.classList.remove('tooltipActive');
    });
    if (iselementActive) {
      targetElement.classList.remove('tooltipActive');
    } else {
      targetElement.classList.add('tooltipActive');
    }
  }


  handleSuccessResponse(resobj) {
    //console.log('Signup API response time => ' + new Date().getTime());
    if(resobj.status === 'Failed') {
      this.signupSetupService.saveSignupSetupModel(this.signupSetupInputData, this.signupSetupOutputData, this.selectedFanList);
      this.handleError('signup');
    } else if (resobj.status === 'Partial Failed' || resobj.status === 'success') {
      if (resobj.status === 'success') {
        let successFanList = resobj.successFanList;
        this.signupSetupOutputData.FANList.awaitingSignupFanList.filter(item => {
          successFanList.filter(f => {
            if(item.fanId === f.fanId) {
              this.successfullySignupFAN.push(item);
            }
          });
        });
        this.signupSetupOutputData.FANList.awaitingSignupFanList = this.successfullySignupFAN;
      }
      this.signupSetupService.saveSignupSetupModel(this.signupSetupInputData, this.signupSetupOutputData, this.selectedFanList);
      // Adobe Analytics Starts
      this.adobeAnalyticsService.createAdobeEventProperties('MANAGE_DEVICE', 'SUCCESS', 'formResponse',
        'BC_Device_SignupSetup_Continue_Submit', 'success', 'Success_Admit', 'Continue', 'Body', '/businessconsole/signupsetup/confirm');
      this.router.navigate(['/signupsetup/confirm']);
    }
  }

  continueToNext() {

    // this.showErrorModel = true;
    this.submitting = true; 
    // this.pageLoaderService.setPageLoaderStatus(false);
    
    this.manageProduct = JSON.parse(sessionStorage.getItem('manage-product'));
    this.emmProductCode = this.manageProduct.emmProductCode;
    this.selectedAccID = this.manageProduct.selectedAccID;

    this.ctnUser = JSON.parse(sessionStorage.getItem('user'));
    this.contactNumber = this.ctnUser.user.contactPhoneNumber;
    
    this.selectedFANs = JSON.parse(sessionStorage.getItem('signupFanList'));
    this.fanInfoList = sessionStorage.getItem('fanInfoList') != 'undefined' ?  JSON.parse(sessionStorage.getItem('fanInfoList')) : [];
    let inactiveList = this.fanInfoList.filter(item => item.accountStatus === 'INACTIVE');
    let activeList = this.fanInfoList.filter(item => item.accountStatus === 'ACTIVE');
    this.revisedFanList = sessionStorage.getItem('fansSignedUp') != 'undefined' ? JSON.parse(sessionStorage.getItem('fansSignedUp')) : [];
    let selectedFansEnrolled = this.selectedFANs.selectedEnrollFans;
    let tempData = [];
    let secondNewFanStatus = [];
    if (selectedFansEnrolled && selectedFansEnrolled.length > 0) { 
      
      selectedFansEnrolled.map( (item) => {
        tempData = this.revisedFanList.filter((x) => x.fanId === item.fanId);
      }); 
    }

    selectedFansEnrolled.forEach(element => {
      if (!this.fanInfoList.includes(element.fanId)) {
        this.secondNewFan = element.fanId;
      }
    });  
    
    selectedFansEnrolled.map((ele) => {
      secondNewFanStatus = inactiveList.filter((y) => y.fanId === ele.fanId);
      this.secondFanStatus = "INACTIVE"
    });


  if(!this.contactNumber) {
    
    if(this.fanInfoList.length == 0 || (inactiveList.length > 0 && activeList.length == 0)) {
      this.signupArray.map((elm) => {
        elm.emailEnabled = true;
        elm.smsEnabled = false;
      });
    }

    else if((tempData.length === 0) && (!this.fanInfoList.includes(this.secondNewFan) || (this.fanInfoList.includes(this.secondNewFan)) && (this.secondFanStatus === "INACTIVE"))) {
      this.signupArray.map((elm) => {
        elm.emailEnabled = true;
        elm.smsEnabled = false;
      });
    }
    else if(tempData.length > 0){
        this.signupArray.map((elm, index) => {
          elm.emailEnabled = (tempData[index].communicationPref == "Email" || tempData[index].communicationPref == "Both") ? true : false;
          elm.smsEnabled = (tempData[index].communicationPref == "Sms" || tempData[index].communicationPref == "Both") ? true : false;
        });
    }
  }


    else {
       if (this.selectedFANs.notificationType === "Both") {
      this.signupArray.map((elm, index) => {
            elm.emailEnabled = true;
            elm.smsEnabled = true;
          });
    } else if (this.selectedFANs.notificationType === "Email") {
      this.signupArray.map((elm) => {
        elm.emailEnabled = true;
        elm.smsEnabled = false;
      });
    } else if (this.selectedFANs.notificationType === "TextMessage") {
      this.signupArray.map((elm) => {
        elm.emailEnabled = false;
        elm.smsEnabled = true;
      });
    }
  }

    this.signupArray.forEach(element => {
      this.eachFan = 
      {
        "memberdetails" : {
          "fanid" : [ element.fanId ]
        },
        "deviceEnrollDate" : {
          "newDate" : element.new,
          "existingDate" : element.existing
        },
        "profileName" : " ",
        "settings" : [
          {
            "newDevNwt": true,
            "extDevNwt": true,
            "securityPolicy": " ",
            "passCodePolicy": " ",
            "emailEnabled": element.emailEnabled,
            "smsEnabled": element.smsEnabled
          }
        ],
        "applications" : []
      }

      // if(sessionStorage.getItem('feFlag') == "true"){
      //   this.eachFan["deviceEnrollDate"] = {
      //     "newDate" : element.new,
      //     "existingDate" : element.existing
      //   }
      // }

      this.fanDetails.push(this.eachFan);
  
    });

    const tncPayload = {
      acceptanceMethod: 'CHECKBOX_CLICK',
      tncVersion: 'v1.0'
    };

    if(sessionStorage.getItem('feFlag') == "true"){
      this.showErrorModel = false;
      this.userData = JSON.parse(sessionStorage.getItem('user'));
      //get firstName and lastName from if admin loggedin in LIC admin
      if(location.href.includes('admin')){
          let firstName = localStorage.getItem('customerFirstName') ? localStorage.getItem('customerFirstName') : this.userData.user.firstName;
          let lastName = localStorage.getItem('customerLastName') ? localStorage.getItem('customerLastName') : this.userData.user.lastName;
          this.firstName = firstName;
          this.lastName = lastName;
      }else{
          this.firstName = this.userData.user.firstName;
          this.lastName = this.userData.user.lastName;
      }
      
      this.userEmail = this.userData.user.emailAddress;
      let ifdResponse = sessionStorage.getItem("romeResponse") ? JSON.parse(sessionStorage.getItem("romeResponse")) : {};
      //validating secondary contacts with premier 
      let secondaryContactFirstName = "", secondaryContactLastName = "", secondaryContactEmail = "", secondaryContactJobTitle = "";
      let responseDetails = ifdResponse?.InquireFanDetailsResponse?.FanDetails;
      if(responseDetails?.CustomerContactDetails && responseDetails?.CustomerContactDetails.length > 0){
        // let secData = responseDetails?.CustomerContactDetails.find(data => data.email != this.userEmail && data.firstName != this.firstName && data.lastName != this.lastName);
        // //let secData = responseDetails?.CustomerContactDetails.filter(data => this.customerRoles.indexOf(data.type.toLowerCase()) != -1);
        // if(!secData){
        //   secondaryContactFirstName = secData ? secData[0].firstName : "";
        //   secondaryContactLastName = secData ? secData[0].lastName : "";
        //   secondaryContactEmail = secData ? secData[0].email : "";
        //   secondaryContactJobTitle = secData ? secData[0].type : "";
        // }else{
        //   this.pageLoaderService.setPageLoaderStatus(true);
        //   this.isFEFailed = true;
        //   this.ABMFEErrorMessage = ERRCODES['ABM_FE_GENERIC_ERROR_MESSAGE'];
        //   return;
        // }
        
      // }else{
        secondaryContactFirstName = responseDetails?.CustomerContactDetails[0].firstName;
        secondaryContactLastName = responseDetails?.CustomerContactDetails[0].lastName;
        secondaryContactEmail = responseDetails?.CustomerContactDetails[0].email;
        secondaryContactJobTitle = responseDetails?.CustomerContactDetails[0].type;
      }else{
        this.pageLoaderService.setPageLoaderStatus(true);
        this.isFEFailed = true;
        this.ABMFEErrorMessage = ERRCODES['ABM_FE_GENERIC_ERROR_MESSAGE'];
        return;
      }

      let orgDetails = responseDetails?.AccountDetails;
      // let orgNameInc = Math.round(Math.random()*1000000);
      this.ABMFE_payload = {
        "requestContext": {
          "shipTo": ABMFE_CONTENTS['SHIP_TO'],
          "timeZone": ABMFE_CONTENTS['TIMEZONE'],
          "langCode": ABMFE_CONTENTS['LANGCODE']
        },
        // "depResellerId": "0000601526",
        "depResellerId": this.utilityService.getEnvConfig().abmfeDepResellerId, //ABMFE_CONTENTS['DEP_RESELLER_ID'],
        "partnerTxnId": ABMFE_CONTENTS['PARTNER_TXN_ID'],
        "enrollmentInfo": {
          "orgType": ABMFE_CONTENTS['ORG_TYPE'],
          "orgName": orgDetails.orgName,
          "orgAddress1": orgDetails.orgAddress1,
          "orgAddress2": orgDetails?.orgAddress2 ? orgDetails?.orgAddress2 : "",
          "orgAddress3": orgDetails?.orgAddress3 ? orgDetails?.orgAddress3 : "",
          "orgPostalCode": orgDetails.orgPostalCode,
          // "orgDUNS": orgDetails?.orgDUNS ? orgDetails?.orgDUNS : "",
          "orgEduMarket": ABMFE_CONTENTS['ORG_EDU_MARKET'],
          "orgPhone": orgDetails.orgPhone,
          "orgRegion": orgDetails.orgRegion,
          "orgCity": orgDetails.orgCity,
          "orgCountry": orgDetails.orgCountry,
          "orgWebsite": ABMFE_CONTENTS['ORG_WEBSITE'],
          "secondaryContactFirstName": secondaryContactFirstName,
          "secondaryContactLastName": secondaryContactLastName,
          "secondaryContactLocale": ABMFE_CONTENTS['SECONDARY_CONTACT_LOCALE'],
          "secondaryContactEmail": secondaryContactEmail,
          "secondaryContactJobTitle": secondaryContactJobTitle,
          "enrolleeFirstName": this.firstName,
          "enrolleeLastName": this.lastName,
          "enrolleeJobTitle": ABMFE_CONTENTS['ENROLEE_JOB_TITLE'],
          "enrolleeEmail": this.userEmail,
          // "enrolleeEmail": this.reviewSignupSetup.enrolleeEmail,//this line is only for testing purpose, not for production
          "enrolleeLocale": ABMFE_CONTENTS['ENROLEE_LOCALE']
        }
      };

      this.fe = {
        "firstName" : this.firstName,
        "lastName" : this.lastName,
        "email" : this.userEmail
      }
      
      this.signupdata = {
        "tnc": tncPayload,
        "signupsetupPayload" : {
          "emmAccountId" : "",
          "emmProductCode" : this.emmProductCode,
          "fanDetails" : this.fanDetails
        },
        "facilitatedEnrollmentRequest" : this.fe,
      }
    }
  
    else{
      this.signupdata = {
        "tnc": tncPayload,
        "emmAccountId" : this.selectedAccID,
        "emmProductCode" : this.emmProductCode,
        "fanDetails" : this.fanDetails
      }
    }
    

    

    //this.signupdata.push(this.fe);

    //console.log(this.signupdata);
    sessionStorage.setItem('enrolledFans', JSON.stringify(this.signupdata));
    

    let tranid = sessionStorage.getItem('tranid');
    if (tranid) {
      this.tranId = tranid.replace(/\"/g, "");
    }

    // if (this.emmProductCode === "DMPAABM" && (sessionStorage.getItem('feFlag') == "false")) {
    //code from prod sel page for apple org id validation call
      //transaction id validation
      //tranIdvalidation code is shifted to product-selection page for release 2309
      // this.signupProcess();
      // this.signupSetupService.tranIdValidation(this.tranId)
      // .subscribe(response => {
      //   if (response.status === 'success') {
      //     this.status = true;
      //     this.setupError = false;
      //     this.signupProcess();
      //   } else if (response.status === 'retry') {
      //     //poll every 20 sec
      //     let poll$ = interval(20000).pipe(
      //       exhaustMap(obs => 
      //         this.signupSetupService.tranIdValidation(this.tranId)),
      //         tap(data => console.log(data))
      //     );
    
      //     const until$ = poll$.pipe(
      //       filter(data => {
      //         //let status: boolean;
      //         if(data.status === 'success') {
      //           this.status = true;
      //           this.setupError = false;
      //           this.signupProcess();
              
      //         } else if (data.status === 'failure') {
      //           this.status = true;
      //           this.pageLoaderService.setPageLoaderStatus(true);
      //           this.setupError = true;
      //           this.isDisabled = true;
      //           sessionStorage.setItem('failFromReviewFlag', 'true');
      //           this.utilityService.loadFocusOnTop();
    
      //         } else {
      //           let time = Date.now() - this.timerStart;
      //           this.status = (time > 45000);
      //           if (this.status) {
      //             this.pageLoaderService.setPageLoaderStatus(true);
      //             this.setupError = true;
      //             this.isDisabled = true;
      //             sessionStorage.setItem('failFromReviewFlag', 'true');
      //             this.utilityService.loadFocusOnTop();
      //           }
      //         }
      //         return this.status;
      //       })
      //     );
        
      //     const data$ = poll$.pipe(
      //       takeUntil(until$))
      //       .subscribe();
    
      //     this.timerStart = Date.now();

      //   } else if (response.status === 'failure') {
      //     this.status = true;
      //     this.pageLoaderService.setPageLoaderStatus(true);
      //     this.setupError = true;
      //     this.isDisabled = true;
      //     sessionStorage.setItem('failFromReviewFlag', 'true');
      //     this.utilityService.loadFocusOnTop();
      //   }
      // }, error => {
      //     this.pageLoaderService.setPageLoaderStatus(true);
      //     this.isDisabled = true;
      //     this.handleError('signup');
      //     this.adobeAnalyticsService.createAdobeEventProperties('MANAGE_DEVICE', 'FAILURE', 'formResponse',
      //       'BC_Device_SignupSetup_Continue_Submit', 'SystemFailure',
      //       'Failure_user', 'Continue', 'Body', '/businessconsole/signupsetup/enrollmentoptions');
      // });

      // let poll$ = interval(20000).pipe(
      //   exhaustMap(obs => 
      //     this.signupSetupService.tranIdValidation(this.tranId)),
      //     tap(data => console.log(data))
      // );

      // const until$ = poll$.pipe(
      //   filter(data => {
      //     //let status: boolean;
      //     if(data.status === 'success') {
      //       this.status = true;
      //       this.setupError = false;
      //       this.signupProcess();
          
      //     } else if (data.status === 'failure') {
      //       this.status = true;
      //       this.pageLoaderService.setPageLoaderStatus(true);
      //       this.setupError = true;
      //       this.isDisabled = true;
      //       sessionStorage.setItem('failFromReviewFlag', 'true');
      //       this.utilityService.loadFocusOnTop();

      //     } else {
      //       let time = Date.now() - this.timerStart;
      //       this.status = (time > 60000);
      //       if (this.status) {
      //         this.pageLoaderService.setPageLoaderStatus(true);
      //         this.setupError = true;
      //         this.isDisabled = true;
      //         sessionStorage.setItem('failFromReviewFlag', 'true');
      //         this.utilityService.loadFocusOnTop();
      //       }
      //     }
      //     return this.status;
      //   })
      // );
    
      // const data$ = poll$.pipe(
      //   takeUntil(until$))
      //   .subscribe();

      // this.timerStart = Date.now();

    // } else 
    // if (this.emmProductCode === "DMPGZTP" || this.emmProductCode === "DMPSKME") {
    //   this.pageLoaderService.setPageLoaderStatus(false);
    //   this.signupProcess();
    // }
    // else if(sessionStorage.getItem('feFlag') == "true"){
    //   this.pageLoaderService.setPageLoaderStatus(false);
    //   this.signupProcess();
    // }
    this.signupProcess();

  }


  signupProcess() {
      this.pageLoaderService.setPageLoaderStatus(false);
    // this.submitting = true;
    // this.pageLoaderService.setPageLoaderStatus(false);
    
    // const manageProduct = JSON.parse(sessionStorage.getItem('manage-product'));
    // const emmProductCode = manageProduct.emmProductCode;
    // const selectedAccID = manageProduct.selectedAccID;
      
    // this.selectedFANs = JSON.parse(sessionStorage.getItem('signupFanList'));
    // if (this.selectedFANs.notificationType === "Both") {
    //   this.email = true;
    //   this.sms = true;
    // } else if (this.selectedFANs.notificationType === "Email") {
    //   this.email = true;
    //   this.sms = false;
    // } else if (this.selectedFANs.notificationType === "TextMessage") {
    //   this.email = false;
    //   this.sms = true;
    // }

    
    // this.signupArray.forEach(element => {
    //   this.eachFan = 
    //   {
    //     "memberdetails" : {
    //       "fanid" : [ element.fanId ]
    //     },
    //     "deviceEnrollDate" : {
    //       "new" : element.new,
    //       "existing" : element.existing
    //     },
    //     "profileName" : " ",
    //     "settings" : [
    //       {
    //         "newDevNwt": true,
    //         "extDevNwt": true,
    //         "securityPolicy": " ",
    //         "passCodePolicy": " ",
    //         "emailEnabled": this.email,
    //         "smsEnabled": this.sms
    //       }
    //     ],
    //     "applications" : []
    //   }

    //   this.fanDetails.push(this.eachFan);
  
    // });
    // console.log(this.fanDetails);

    // this.signupdata = {
    //   "emmAccountId" : this.selectedAccID,
    //   "emmProductCode" : this.emmProductCode,
    //   "fanDetails" : this.fanDetails
    // }
    // console.log(this.signupdata);

    if (this.utilityService.getEnvConfig().useMock) {
      //sessionStorage.setItem('enrolledFans', JSON.stringify(this.signupdata));
      //updating user object with signupstatus
      this.user = JSON.parse(sessionStorage.getItem('user')).user;

      if (this.user.addpAuthority !== 'NONE') {
        this.authenticationService.getFanSignedUpStatus()
        .subscribe(resp => {
          if (this.user) {
            for (var key of Object.keys(this.user)) {
              if (key === "fanSignedUpStatus") {
                delete this.user[key];
              }
            }
            //console.log(retrieveArray);
            this.user.fanSignedUpStatus = this.getFanSignedUpStatus(resp.fansSummary);
            //to get all available for signup ABM fans
            
            let awaitingarray = [];
            resp.fansSummary.filter(item => {
              if(item.status === "AWAITING_SIGNUP") {
                item.fans.forEach(element => {
                  awaitingarray.push(element);
                });
              }
            });
            if (awaitingarray !== null) {
              if (awaitingarray.length > 0 ) {
                sessionStorage.setItem('availableFansFlag', 'true');
              } else {
                sessionStorage.setItem('availableFansFlag', 'false');
              }
            }
          }
          this.authenticationService.setUser(this.user);

          this.router.navigate(['/signupsetup/confirm']);

          //appledep scenario start
          // this.signupSetupService.signupDep()
          // .subscribe(resobj => {
          //   if (resobj.errors[0].errorCode === '460') {
          //     let depFans = resobj.errors[0].errorDescription;
          //     let keyValuePairs = depFans.slice(1, -1)  //remove first and last character
          //       .split(/\s*,\s*/)                       //split with optional spaces around the comma
          //       .map(chunk => chunk.split("="));        //split key=value
  
          //     const fanMap = new Map(keyValuePairs);
          //     for (let [key, value] of fanMap.entries()) {
          //       if (value === 'Failure') {
          //         this.failArray.push(key);
          //       }
          //     }
          //     if (this.failArray.length <= 5) {
          //       this.showFansFlag = true;
          //     } else {
          //       this.showFansFlag = false;
          //     }

          //     //console.log(this.failArray);
          //     sessionStorage.setItem('cacheFlag', 'true');
          //     this.isDisabled = true;
          //     this.utilityService.loadFocusOnTop();
          //     this.submitting = false;
          //     this.depError = true;
          //     this.pageLoaderService.setPageLoaderStatus(true);
              
          //   }
          // },
          //   error => {
          //     this.user.fanSignedUpStatus = 'Error';
          //     this.authenticationService.setUser(this.user);
          //     this.pageLoaderService.setPageLoaderStatus(true);
          //   }
          // );
          //apple dep scenario end
          

        }, () => {
          this.user.fanSignedUpStatus = 'Error';
          this.authenticationService.setUser(this.user);
          this.router.navigate(['/signupsetup/confirm']);
        });
      } else {
        this.authenticationService.setUser(this.user);
        this.router.navigate(['/signupsetup/confirm']);
      }
      //this.router.navigate(['/signupsetup/confirm']);

    } else {
      this.signupSetupService.submitSignupSetup(this.signupdata)
        .subscribe(resobj => {
          this.signupSetupError = '';
          if (resobj.status && resobj.status.toLowerCase() === 'success') {
            //this.pageLoaderService.setPageLoaderStatus(true);
            let successFanList = resobj.successFanList;
            this.selectedFANs.enrolledFans = successFanList;
            //updating user object with signupstatus
            this.user = JSON.parse(sessionStorage.getItem('user')).user;

            if (this.user.addpAuthority !== 'NONE') {
              this.authenticationService.getFanSignedUpStatus()
              .subscribe(resp => {
                if (this.user) {
                  for (var key of Object.keys(this.user)) {
                    if (key === "fanSignedUpStatus") {
                      delete this.user[key];
                    }
                  }
                  //console.log(retrieveArray);
                  sessionStorage.setItem("accountSummaryData", JSON.stringify(resp));
                  this.user.fanSignedUpStatus = this.getFanSignedUpStatus(resp.fansSummary);
                  
                  let awaitingarray = [];
                  resp.fansSummary.filter(item => {
                    if(item.status === "AWAITING_SIGNUP") {
                      item.fans.forEach(element => {
                        awaitingarray.push(element);
                      });
                    }
                  });
                  
                  if (awaitingarray !== null) {
                    if (awaitingarray.length > 0 ) {
                      sessionStorage.setItem('availableFansFlag', 'true');
                    } else {
                      sessionStorage.setItem('availableFansFlag', 'false');
                    }
                  }
                  

                }

                //show/hide register/enroll menu based on new FAn enrollment
                this.authenticationService.updateEnrollStatus({noOfFans: resp.noOfFans, fanInfoList: resp.fanInfoList});

                this.authenticationService.setUser(this.user);
                this.pageLoaderService.setPageLoaderStatus(true);
                let ABMFE = sessionStorage.getItem("ABMFE") ? JSON.parse(sessionStorage.getItem("ABMFE")) : false;
                if(sessionStorage.getItem('feFlag') == "true" && ABMFE === true ){
                  this.ABMfacilitatedEnrollment(resobj.statusDescription);
                }else{
                  this.router.navigate(['/signupsetup/confirm']);
                }
                
              }, () => {
                this.user.fanSignedUpStatus = 'Error';
                this.authenticationService.setUser(this.user);
                this.pageLoaderService.setPageLoaderStatus(true);
                this.router.navigate(['/signupsetup/confirm']);
              });
            } else {
              this.authenticationService.setUser(this.user);
              this.pageLoaderService.setPageLoaderStatus(true);
              this.router.navigate(['/signupsetup/confirm']);
            }
            //setting user ends
            this.adobeAnalyticsService.createAdobeEventProperties('MANAGE_DEVICE', 'SUCCESS', 'formResponse',
            'BC_Device_SignupSetup_Continue_Submit', 'success', 'Success_Admit', 'Continue', 'Body', '/businessconsole/signupsetup/confirm');
            //this.router.navigate(['/signupsetup/confirm']);
          }else if(resobj["errors"] && resobj["errors"][0].errorCode === '503'){
            this.pageLoaderService.setPageLoaderStatus(true);
            this.isDisabled = true;
            this.signupSetupError = resobj["errors"][0].errorDescription;
            this.handleError('signup');
          }else{
            this.pageLoaderService.setPageLoaderStatus(true);
            this.isDisabled = true;
            this.handleError('signup');
          }
          
        }, error => {
          if (error !== undefined && error !== null) {
            if (error.status === 504 || error.status === 500) {
              this.pageLoaderService.setPageLoaderStatus(true);
              this.isDisabled = true;
              this.handleError('signup');
              this.adobeAnalyticsService.createAdobeEventProperties('MANAGE_DEVICE', 'FAILURE', 'formResponse',
                'BC_Device_SignupSetup_Continue_Submit', 'SystemFailure',
                'Failure_user', 'Continue', 'Body', '/businessconsole/signupsetup/enrollmentoptions');
            }
            //apple DEP signup failure scenario start
            else if (error.error.errors[0].errorCode !== undefined) {
              if (error.error.errors[0].errorCode === '460') {
                let depFans = error.error.errors[0].errorDescription;
                let keyValuePairs = depFans.slice(1, -1)  //remove first and last character
                  .split(/\s*,\s*/)                       //split with optional spaces around the comma
                  .map(chunk => chunk.split("="));        //split key=value

                const fanMap = new Map(keyValuePairs);
                for (let [key, value] of fanMap.entries()) {
                  if (value === 'Failure') {
                    this.failArray.push(key);
                  }
                }
                if (this.failArray.length <= 5) {
                  this.showFansFlag = true;
                } else {
                  this.showFansFlag = false;
                }
                //console.log(this.failArray);
                sessionStorage.setItem('cacheFlag', 'true');
                this.isDisabled = true;
                this.utilityService.loadFocusOnTop();
                this.submitting = false;
                this.depError = true;
                this.pageLoaderService.setPageLoaderStatus(true);
                //apple dep scenario end
              }

            } else {
              this.pageLoaderService.setPageLoaderStatus(true);
              this.isDisabled = true;
              this.handleError('signup');
              this.adobeAnalyticsService.createAdobeEventProperties('MANAGE_DEVICE', 'FAILURE', 'formResponse',
                'BC_Device_SignupSetup_Continue_Submit', 'SystemFailure',
                'Failure_user', 'Continue', 'Body', '/businessconsole/signupsetup/enrollmentoptions');
            }
          }
        });
    }
  }

  handleError(error) {
    if (error) {
      this.isDisabled = true;
      this.utilityService.loadFocusOnTop();
      this.submitting = false;
      this.showErrors = true;
    }
  }

  private getFanSignedUpStatus(fansSummary) {
    let fanSignedUpStatus = 'NONE';
    if (fansSummary) {
      const signedUpFansCount = fansSummary.
        filter((f) => { return f.status === 'ACTIVE' || f.status === 'READY_TO_SETUP'; }).length;
      const notSignedUpFansCount = fansSummary.
        filter((f) => { return f.status === 'PROCESSING' || f.status === 'AWAITING_SIGNUP'; }).length;
      if (signedUpFansCount > 0 && notSignedUpFansCount > 0) {
        fanSignedUpStatus = 'SOME';
      } else if (signedUpFansCount > 0 && notSignedUpFansCount === 0) {
        fanSignedUpStatus = 'ALL';
      } else {
        fanSignedUpStatus = 'NONE';
      }
    }
    return fanSignedUpStatus;
  }
  
  ABMfacilitatedEnrollment(abmOrgIdTransactionID){
      this.pageLoaderService.setPageLoaderStatus(false);
      this.ABMFE_payload["abmOrgIdTransactionID"] = abmOrgIdTransactionID;
      //call to ABM FE partner
      // console.log("abmOrgIdTransactionID==>", abmOrgIdTransactionID);
      // console.log("this.ABMFE_payload===>", this.ABMFE_payload);
      this.signupSetupService.sendABMFERequest(this.ABMFE_payload).subscribe((resp: any) => {
        this.pageLoaderService.setPageLoaderStatus(true);
        // console.log("ABM FE Response: ", resp);
        // if(resp.hasProperty("facilitatedEnrollmentResponse")){//success response
        if(resp.status == 'SUCCESS'){
          this.isFEFailed = false;
          this.isFEFailedWithError = false;
         // this.ABMFESuccessMessage = resp?.facilitatedEnrollmentResponse?.statusMessage;
          this.router.navigate(['/signupsetup/confirm']);
        }else{//failure response
          this.isFEFailed = true;
          this.isFEFailedWithError = false;
          this.ABMFEErrorMessage = ERRCODES['ABM_FE_GENERIC_ERROR_MESSAGE'];
          window.scrollTo(0, 0);
        }
      }, (error: any) => {
        if(error && error.status == 400 && error['error'].status != ''){
          this.isFEFailed = false;
          this.isFEFailedWithError = true;
          this.ABMFEErrorMessage = this.reviewSignupSetup.abmfeErrorMessageHeading;
          let errStatus = error['error'].status;
          this.ABMFEErrorMessageDescription = errStatus.split(",").filter(item => item !== "");
          this.ABMFEErrorMessageFooter = this.reviewSignupSetup.abmfeErrorMessageFooter;
          window.scrollTo(0, 0);
        }else if(error && error.status == 400){
          this.isFEFailed = true;
          this.ABMFEErrorMessage = ERRCODES['ABM_FE_GENERIC_ERROR_MESSAGE'];
        }else {
          this.isFEFailed = true;
          this.ABMFEErrorMessage = ERRCODES['ABM_FE_COMMON_ERROR_MESSAGE'];
        }
          this.pageLoaderService.setPageLoaderStatus(true);
          window.scrollTo(0, 0);
          console.error(error);
      })

    }

}
